import React, { useEffect, useState, useRef } from 'react';
import Modal from '@components/common/Modal';
import style from './index.module.css';
import { APP_CONFIG } from '@constants';
import { LABEL, CUSTOM_MESSAGES } from '../../../veriables';
import EventEmitter from '@utility/eventSubscribers';
import { getObjectValue } from '@utility/helperFunction';
import { flowType } from '@utility/userInfo';
import { isEmpty } from 'lodash';
import { showSuccessCheckMark, setErrorPopup } from '../../../reducers/notification';
import {bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import { setOpenModalPopUp } from '@reducers/orders';
import { TouchableButton } from '@components/common/Touchable';

const InActivity = (props) => {
  const { inActivityStatus } = props;
  const returnTimerInterval = (type) => {
    switch (type) {
      // case 'serverApp': return props.deviceInfo?.deviceGroup?.timeoutInterval <= 10 ? props.deviceInfo?.deviceGroup?.timeoutInterval - 10 : props.deviceInfo?.deviceGroup?.timeoutInterval - 10;
      case 'serverApp': return props.deviceInfo?.deviceGroup?.timeoutInterval - 10;
      default: return 60;
    }
  };
// console.log(props.speedOrderStatus,"grgrgrgrg");
  const returnRemainingTime = (type) => {
    switch (type) {
      // case 'serverApp': return props.deviceInfo?.deviceGroup?.timeoutInterval <= 10 ? 10 : 10;
      case 'serverApp': return 10;
      default: return 30;
    }
  };
  const isServer = flowType() === 'serverApp';
  const isTableTop = flowType() === 'tableTop';
  const isKiosk = flowType() === 'kiosk';
  const [isOpen, setIsOpen] = useState(false);
  const timeInterval = props.deviceInfo?.deviceGroup?.timeoutInterval ? returnTimerInterval(isServer ? 'serverApp' : '') : 60;
  const remainingTime = props.deviceInfo?.deviceGroup?.timeoutInterval ? returnRemainingTime(isServer ? 'serverApp' : '') : 30;
  const isCounter = getObjectValue(() => isServer && [1].includes(props.deviceInfo.deviceGroup.startMode), false);
  const isOrderPayMode = getObjectValue(() => isTableTop && [1].includes(props.deviceInfo.deviceGroup.startMode), false);
  const [count, setCount] = useState(() => { return isKiosk ? 90 : remainingTime; });
  const timerId = useRef(null);
  const cancelOrderCheck = () => {
    props.setOpenModalPopUp(false);
    window.sessionStorage.removeItem('counterName');
		  window.sessionStorage.removeItem('counterPhone');
		window.sessionStorage.removeItem('taxExempt');
		window.sessionStorage.removeItem('counterCountry');
    const check = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('seat')), []);
    const dataToSend = {
      employeeId: getObjectValue(() => Number(props.userInfo.id), JSON.parse(window.sessionStorage.getItem('userInfo')).id),
      storeId: props.deviceInfo.storeId,
      checkHeaderId: check?.id || JSON.parse(window.sessionStorage.getItem('seat'))?.id,
      deviceId: props.deviceInfo.deviceId,
        };
   
    if (isKiosk) {
      if (check?.open || JSON.parse(window.sessionStorage.getItem('seat'))?.open || check?.unPaidAmount > 0) {
        props.checkVoid(dataToSend);
      }
      props.setIsAssisstance(false);
      props.clearCart();
      props.removeSeat();
      props.clearAuthResponse();
      props.removePaymentCheck();
      props.history.replace({
        pathname: `${APP_CONFIG.BASE_URL}/${flowType()}/landing`,
      });
    } else {
      props.checkVoid(dataToSend).then((res) => {
        props.updateChecksAfterResponse(res);
        if (isCounter || window.sessionStorage.getItem('speedStatus')) {
          window.sessionStorage.removeItem('speedStatus');
          props.history.replace(`${APP_CONFIG.BASE_URL}/checkIn?step=1`);
        } else {
          props.history.replace({
            pathname: `${APP_CONFIG.BASE_URL}/${flowType()}/checks`,
          });
        }
      }).catch((e) => {
        props.setNotification({
          type: 'danger',
          message: e.message
        });
      });
    }
  };
  

  const addCheck = (inProcessItems, cb) => {
    const check = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('seat')), []);
    if (inProcessItems.length === 0) {
      cb();
    } else {
      const dataToSend = {
        storeId: props.deviceInfo.storeId,
        deviceId: props.deviceInfo.deviceId,
        employeeId: Number(props.userInfo.id),
        employeeCard: props.userInfo.employeeCard,
        checkHeaderId: check.id,
        stationId: check.stationId,
        items: inProcessItems,
        orderJson: JSON.stringify(inProcessItems),
        longitude: '0',
        latitude: '0',
        geoLocation: '0'
      };
      props.addChecks(dataToSend, 'add').then((res) => {
        props.updateChecksAfterResponse(res);
        cb(res);
      }).catch((e) => {
        props.setNotification({
          type: 'danger',
          message: e.message
        });
      });
    }
  };
 
  const handleClose = () => {
    const check = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('seat')), []);
           const type = !props.deviceInfo?.deviceGroup?.inputFields?.nameEnabled && !props.deviceInfo?.deviceGroup?.inputFields?.phoneNumberEnabled;
    const dataToSend = {
      employeeId: Number(props?.userInfo?.id),
      storeId: props?.deviceInfo?.storeId,
      checkHeaderId: check?.id || JSON.parse(window.sessionStorage.getItem('seat'))?.id,
      deviceId: props?.deviceInfo?.deviceId,
    };
    if (dataToSend.checkHeaderId) {
      props.checkVoid(dataToSend).then((res) => {
        props.clearCart();
        props.updateChecksAfterResponse(res).then(() => {
          if (props?.deviceInfo?.deviceGroup?.startMode === 2) {
            props.history.push(({ pathname: `${APP_CONFIG.BASE_URL}/callCenterError` }));
            setIsOpen(false);
            return;
          } else {
            props.history.replace({
              pathname: `${APP_CONFIG.BASE_URL}/${flowType()}/checks`,
              state: { type: type ? 'checks' : 'order' }
            });
            if (window.ReactNativeWebView && (isServer || isTableTop)) {
              EventEmitter.changeOrientation({
                orientation: "landscape"
              })
          }
          }
        });
      }).catch((e) => {
        props.setNotification({
          type: 'danger',
          message: e.message
        });
      });
    } else {
      props.history.push(({ pathname: `${APP_CONFIG.BASE_URL}/callCenterError` }));
      setIsOpen(false);
      return;
    }
  };

  const signOut = () => {
    if (window.sessionStorage.getItem('launchFromExternalDevice')) {
      window.sessionStorage.removeItem('launchFromExternalDevice')
    }
    if (props?.deviceInfo?.deviceGroup?.startMode === 2) {
      handleClose()
      return 
    }
    setIsOpen(!isOpen);
    const items = [];
    const cart = JSON.parse(window.sessionStorage.getItem('cart')) || [];
    const checkItems = JSON.parse(window.sessionStorage.getItem('seat'))?.orders && JSON.parse(window.sessionStorage.getItem('seat'))?.orders[0]?.items || [];
    if (flowType()!=='tableTop' && props?.deviceInfo?.deviceGroup?.startMode === 2) {
      handleClose();
    }
    if (checkItems?.length > 0) {
      checkItems?.forEach((v) => {
        if (v.itemType !== 'D' && v.pending) {
          const orderJson = JSON.parse(v.orderJson);
          const modifierJson = JSON.parse(orderJson.modifierJson);
          if (v.isProcessing) {
            items.push({
              ...v,
              ...orderJson,
              ...modifierJson
            });
          }
        }
      });
    }
    const inProcessItems = cart.filter((e) => e.isProcessing)?.length > 0 ? cart.filter((e) => e.isProcessing) : getObjectValue(() => items, []);
    if (timerId.current) {
      clearInterval(timerId.current);
      setCount(isKiosk ? 90 : remainingTime);
    }
    props.setInActivityStatus(false);
    if (window.ReactNativeWebView) {
      // EventEmitter.postInactiveStatus(false);
      // EventEmitter.postScreenSaverStatus(isServer);
    }
    props.setScreenSaverStatus(isServer);
    if ((isOrderPayMode || isKiosk || isCounter || window.sessionStorage.getItem('speedStatus') ) && !isEmpty(JSON.parse(window.sessionStorage.getItem('seat')))) {
      if (isCounter || window.sessionStorage.getItem('speedStatus')) {
        const cb = () => {
          cancelOrderCheck();
        };
        addCheck(inProcessItems, cb);
      } else {
        cancelOrderCheck();
      }
    } else if (isServer) {
      const cb = () => {
        const dataToSend = {
          latitude: '92',
          longitude: '92',
          deviceId: props.deviceInfo.deviceId,
          employeeId: getObjectValue(() => props.userInfo.externalId, null),
          employeeCard: getObjectValue(() => props.userInfo.employeeCard, null),
        };
        props.logout(dataToSend).then(() => props.showSuccessCheckMark())
        props.history.replace(`${APP_CONFIG.BASE_URL}/checkIn?step=1`);
        if (window.ReactNativeWebView && (isServer || isTableTop)) {
          EventEmitter.changeOrientation({
            orientation: "landscape"
          })
        }
      };
      addCheck(inProcessItems, cb);
    } else {
      const cb = (res) => {
        props.setSeat(res).then(() => {
          props.history.replace({
            pathname: `${APP_CONFIG.BASE_URL}/${flowType()}/checks`,
          });
        });
      };
      addCheck(inProcessItems, cb);
    }
    setIsOpen(false);
    props.setInActivityStatus(false);
  };
  const startTimer = () => {
    let val = isKiosk ? 90 : remainingTime;
    setCount(val);
    if (timerId.current) {
      clearInterval(timerId.current);
    }
    timerId.current = setInterval(() => {
      if (val > 0) {
        val -= 1;
        setCount(val);
      } else if (val === 0) {
        clearInterval(timerId.current);
        signOut();
      } else {
        clearInterval(timerId.current);
      }
    }, 1000);
  };

  const openInactivatityPopup = () => {
    const url = props.history.location.pathname;
    if ((isKiosk || isServer || isTableTop) && !url.includes('/receipt') && !url.includes('/checkIn') && !url.includes('/activate') && !url.includes('/activationCode') && !url.includes('/kiosk/checks') && !url.includes('/kiosk/landing') && !url.includes('/kiosk/kioskOrder') && !props.stopPopUp && !url.includes('/callCenterError') && !url.includes('/stagepayment') && !url.includes('/tableTop/checks')) {
      setIsOpen(true);
      startTimer();
    }
  };

  const timer = useRef(null);

  const startInactivityTimer = () => {
    if (timer.current) {
      clearInterval(timer.current);
    }
    let value = 0;
    timer.current = setInterval(() => {
      value += 1;
      if (timeInterval === 0 || value === timeInterval) {
        openInactivatityPopup();
        clearInterval(timer.current);
        return isOpen && inActivityStatus ? startInactivityTimer() : '';
      }
      return '';
    }, 1000);
  };

  const rootElement = document.querySelector('#root');
  const events = ['click', 'dblclick', 'touchstart', 'touchmove', 'touchend', 'touchcancel'];
  events.forEach((event) => {
    // window.addEventListener(event, () => startInactivityTimer(), false);
    rootElement.addEventListener(event, () => startInactivityTimer(), false);
  });

  useEffect(() => {
    if (inActivityStatus) {
      clearInterval(timer?.current);
      startInactivityTimer();
    } else if (timer.current) {
      clearInterval(timer.current);
      startInactivityTimer();
    }
    // if ((isKiosk) && !url.includes('/kiosk/checks') && !url.includes('/kiosk/landing') && !url.includes('/kiosk/kioskOrder') && !url.includes('/kiosk/pay')) {
    //   startInactivityTimer();
    // }
    return () => {
      if (timerId.current) {
        clearInterval(timerId.current);
      }
      if (timer.current) {
        clearInterval(timer.current);
      }
      events.forEach((event) => {
        // window.removeEventListener(event, () => startInactivityTimer(), false);
        rootElement.removeEventListener(event, () => startInactivityTimer(), false);
      });
    };
  }, [inActivityStatus, props.stopPopUp]);

  const handleStay = () => {
    props.setScreenSaverStatus(isServer);
    if (window.ReactNativeWebView) {
      // EventEmitter.postInactiveStatus(true);
      // EventEmitter.postScreenSaverStatus(isServer);
    }
    if (timerId.current) {
      clearInterval(timerId.current);
      setCount(isKiosk ? 90 : remainingTime);
    }
    props.setInActivityStatus(false);
  };

  const kioskLabel = () => {
    const check = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('seat')), []);
    return !check?.unPaidAmount > 0 || !check?.open ? LABEL().STAY : LABEL().CONTINUE_ORDER;
  };

  const kioskCustomMessage = () => {
    const check = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('seat')), []);
    return check?.open || check?.unPaidAmount > 0 ? `${CUSTOM_MESSAGES().IN_ACTIVITY_MESSAGE} ${count} ${LABEL().SECONDS}. ${CUSTOM_MESSAGES().PLEASE_MAKE_SELECTION}` : `${CUSTOM_MESSAGES().IN_RECEIPT_ACTIVITY_MESSAGE} ${count}  ${LABEL().SECONDS}. ${CUSTOM_MESSAGES().PLEASE_MAKE_SELECTION}`;
  };

  const isCancelOrder = () => {
    const check = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('seat')), []);
    return check?.open || check?.unPaidAmount > 0;
  };
  return (
    <Modal
      isOpen={isOpen}
      isModalCenter
      customClass2={isKiosk ? style.maxWidth : ''}
    >
      <div className="col-12 py-2 od-text-primary text-primary">
        {(isServer || isTableTop) && (
          <div className="col-12 w-100 px-0 fw-600 text-center fs-26">{`${CUSTOM_MESSAGES().INACTIVITY_LOG_OUT} ${count}  ${LABEL().SECONDS}.`}</div>
        )}
        {isKiosk && (
          <div className="col-12 w-100 px-0 fw-600 text-center fs-26">{kioskCustomMessage()}</div>
        )}
        <div className="col-12 w-100 row mx-0 py-2 px-0 justify-content-center align-items-center text-center">
          {isKiosk && isCancelOrder() && (
            <div className="col-6">
              <button className="w-100 btn btn100 btn-secondary od-btn-secondary" type="button" onClick={() => { signOut(); }}>
                <div className="fs-18">{LABEL().CANCEL_ORDER}</div>
              </button>
            </div>
          )}
          {(isServer || isTableTop || isOrderPayMode) && (
            <div className="col-6">
              <TouchableButton className="w-100 btn btn100 btn-secondary od-btn-secondary" type="button" onClick={(event) => {event.preventDefault(); signOut(); }}>
                <div className="fs-18">{(isOrderPayMode) ? LABEL().CANCEL_ORDER : LABEL().LOG_OUT}</div>
              </TouchableButton>
            </div>
          )}
          <div className="col-6">
            <TouchableButton className="w-100 btn btn100 btn-primary btn-ripple od-btn-primary" id="myBtn" type="button" onClick={(event) => {event.preventDefault(); setIsOpen(false); handleStay(); }}>
              <div className="fs-18">{isKiosk ? kioskLabel() : LABEL().STAY}</div>
            </TouchableButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};

const mapDispatchToProps = dispatch => bindActionCreators({
  showSuccessCheckMark,
  setErrorPopup,
  setOpenModalPopUp
}, dispatch)

export default connect(null, mapDispatchToProps)(InActivity);
